import { usePersonReadDataContext } from '@aibees/elephant/context';
import { isJobChangeHappened } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/utils';
import { classnames } from '@aibees/shared/utils';
import { Alert } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { JobChangeAlertMessageProps as Props } from './types';

export const JobChangeAlertMessage = memo(({ className }: Props) => {
  const { api } = usePersonReadDataContext();

  const hasJobChange = isJobChangeHappened(api?.data);

  if (!hasJobChange) return null;

  return (
    <Alert
      className={classnames('JobChangeAlertMessage', className)}
      variant="standard"
      severity="info"
      sx={SX.root}
      icon={false}
    >
      {`${api.data?.profile?.first_name} has started a new Position at ${api.data?.company?.summary?.name}`}
    </Alert>
  );
});

JobChangeAlertMessage.displayName = 'JobChangeAlertMessage';
